import { BlockList } from '@zillow/cms-blocks';
import React from 'react';

import Footer from '../../components/Homeloans/Footer';
import Layout from '../../components/Layout/Layout';
import {
    buildPrimaryPostPage,
    LayoutComponentProps,
    PostPageContentProps,
} from '../../util/buildPrimaryPostPage';

const HomeloansContent: React.FC<{
    post: PostPageContentProps['post'];
    preview?: boolean;
}> = ({ post }) => {
    return (
        <>
            <BlockList blocks={post?.blocks || []} />
            <Footer />
        </>
    );
};

const HomeloansLayout: React.FC<LayoutComponentProps> = (props) => {
    return (
        <Layout head={props.head} menu={props.menu} preview={props.preview}>
            {props.children}
        </Layout>
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'ZHL',
        basePath: '/homeloans',
        LayoutComponent: HomeloansLayout,
        ContentComponent: HomeloansContent,
        pathFormatter: (slug) =>
            '/homeloans' + (slug[0] === '/' ? '/' : '/' + slug.join('/') + '/'),
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
